import { render, staticRenderFns } from "./OnboardingWizardHeading.vue?vue&type=template&id=2ae971c8&scoped=true"
import script from "./OnboardingWizardHeading.vue?vue&type=script&lang=js"
export * from "./OnboardingWizardHeading.vue?vue&type=script&lang=js"
import style0 from "./OnboardingWizardHeading.vue?vue&type=style&index=0&id=2ae971c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae971c8",
  null
  
)

export default component.exports